module.exports = __webpack_public_path__ + "static/media/cat1.71faf842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/cat1.jpg
// module id = 1095
// module chunks = 21